import React from 'react';
import { LockIcon, ZapIcon, CheckCircleIcon } from 'lucide-react';
export function TrustBadges() {
  return <div className="flex justify-center" data-id="element-289" data-mp="2oizvaoh43xds">
      <div className="bg-[#1B3022] rounded-2xl px-6 py-3 inline-flex flex-col sm:flex-row items-center gap-3 sm:gap-8" data-id="element-290" data-mp="2okb3d0hlbrap">
        <div className="flex items-center gap-2" data-id="element-291" data-mp="2xiwismrrmq79">
          <LockIcon className="w-4 h-4 text-[#e8943a]" data-id="element-292" data-mp="2xi4yi83mcewa" />
          <span className="text-sm font-medium text-white/90" data-id="element-293" data-mp="3cfxcgvtiov8d">
            Compra 100% segura
          </span>
        </div>
        <div className="flex items-center gap-2" data-id="element-294" data-mp="37g15qotfqpp4">
          <ZapIcon className="w-4 h-4 text-[#e8943a]" data-id="element-295" data-mp="37f9ko7xgsad3" />
          <span className="text-sm font-medium text-white/90" data-id="element-296" data-mp="3l7frv4in370e">
            Acceso inmediato al PDF
          </span>
        </div>
        <div className="flex items-center gap-2" data-id="element-297" data-mp="3h7ozwxhdmkua">
          <CheckCircleIcon className="w-4 h-4 text-[#22c55e]" data-id="element-298" data-mp="3v5vht45xka8b" />
          <span className="text-sm font-medium text-white/90" data-id="element-299" data-mp="3v4by13l2fh1s">
            Garantía de 7 días
          </span>
        </div>
      </div>
    </div>;
}